import Swiper from "swiper";
import { Navigation, Autoplay } from "swiper/modules";

export const initEminogluProjects = (): void => {
  const sections = document.querySelectorAll<HTMLElement>(
    "[data-project-tabs]",
  );

  if (sections.length === 0) return;

  sections.forEach((section) => {
    const swiperInstances: Swiper[] = [];

    // 1. Initialize Sliders First
    const sliders = section.querySelectorAll<HTMLElement>(
      ".eminoglu-projects__swiper",
    );
    sliders.forEach((sliderElement) => {
      const wrapper = sliderElement.closest(
        ".eminoglu-projects__slider-wrapper",
      );
      const nextBtn = wrapper?.querySelector(
        ".ea-slider-nav--next",
      ) as HTMLElement;
      const prevBtn = wrapper?.querySelector(
        ".ea-slider-nav--prev",
      ) as HTMLElement;

      const s = new Swiper(sliderElement, {
        modules: [Navigation, Autoplay],
        loop: true,
        spaceBetween: 30,
        grabCursor: true,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        autoplay: { delay: 5000, disableOnInteraction: true },
        navigation: { nextEl: nextBtn, prevEl: prevBtn },
        breakpoints: {
          320: { slidesPerView: 1, spaceBetween: 15 },
          768: { slidesPerView: 2.2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 30 },
        },
      });
      swiperInstances.push(s);
    });

    // 2. Tab Logic with Swiper Update
    const tabBtns = section.querySelectorAll<HTMLButtonElement>(
      ".eminoglu-projects__tab-btn",
    );
    const panels = section.querySelectorAll<HTMLElement>(
      ".eminoglu-projects__panel",
    );

    tabBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        tabBtns.forEach((b) => {
          b.classList.remove("is-active");
          b.setAttribute("aria-selected", "false");
        });
        panels.forEach((p) => p.classList.remove("is-active"));

        btn.classList.add("is-active");
        btn.setAttribute("aria-selected", "true");

        const targetId = btn.getAttribute("data-target");
        if (targetId) {
          const targetPanel = document.getElementById(targetId);
          if (targetPanel) {
            targetPanel.classList.add("is-active");
            // Force Swiper to recalculate dimensions now that panel is visible
            swiperInstances.forEach((instance) => instance.update());
          }
        }
      });
    });
  });
};
